import './global.js';
import barba from '@barba/core';
import barbaRouter from "@barba/router";
import barbaPrefetch from "@barba/prefetch";
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/all';
import LocomotiveScroll from "locomotive-scroll";
import 'locomotive-scroll/dist/locomotive-scroll.css';

import * as Helper from './classes/Helpers';
import * as ShareLink from './classes/ShareLink';
import StoriesFilters from './classes/StoriesFilters';
import TeamsFilters from './classes/TeamsFilters';
import CompaniesFilters from './classes/CompaniesFilters';
import SwipersSliders from './classes/SwipersSliders';
import SliderStories from './classes/SliderStories.js';
import HomeBanner from './classes/HomeBanner';
import FeedTabs from './classes/FeedTabs';
import ScrollAnimations from './classes/ScrollAnimations';
// import ClockAnimation from './classes/ClockAnimation'; // unused
import * as Newsletter from './classes/Newsletter';
import FoundersSpotlight from './classes/FoundersSpotlight';
import Accordion from './classes/Accordion';
import SliderFounders from "./classes/SliderFounders.js";
import HorizontalTextScroller from './classes/HorizontalTextScroller.js';
import AppearAnimation from './classes/AppearAnimation.js';
import LogoMobileWidth from './classes/LogoMobileWidth.js';
import SpotLight from './classes/Spotlight.js';
import VideoModal from './classes/VideoModal.js';
import VideoModalCarousel from './classes/VideoModalCarousel.js';
import StopMainScroller from './classes/StopMainScroller.js';
import FilterSwitch from './classes/FilterSwitch.js';
import CloseMenu from './classes/CloseMenu.js';
import FocusArea from './classes/FocusArea.js';
import ChartGraph from "./classes/ChartGraph";
import HeroCyber60 from "./classes/HeroCyber60";
// import {classOnLoad} from "./classes/Helpers"; // unused
import Newsletter2024Ai from './classes/newsletter2024-ai/Newsletter2024Ai';
import Cyber60 from './classes/Cyber60';
import Newsletter2025Q1 from "./classes/newsletter2025-q1/Newsletter2025Q1";

gsap.registerPlugin(ScrollTrigger);
const myRoutes = [
	{
		path: '/global-presence/:id',
		name: 'global-presence'
	},
	{
		path: '/team-member/:id',
		name: 'team-member'
	},
	{
		path: '/company/:id',
		name: 'company'
	},
	{
		path: '/jobs/:id',
		name: 'jobs'
	},
	{
		path: '/:post/:id',
		name: 'post'
	}
];

barba.use(barbaRouter, {
	routes: myRoutes,
});

barba.use(barbaPrefetch);

class AppBarba {
	constructor() {
		this.speed = 0.5;
		this.mm = gsap.matchMedia();
		this.init();
	}

	identifierPage({current, next}) {
		var nextElementDom = new DOMParser().parseFromString(next.html, "text/html")
		let classNextElement = nextElementDom.querySelector('body').getAttribute('data-slug');
		const additonalClasses = nextElementDom.querySelector('body').getAttribute('data-additional-classes');
		const element = document.querySelector('body')
		element.classList.remove(...element.classList);
		element.classList.add(classNextElement);

		if(additonalClasses) {
			element.classList.add(additonalClasses);
		}
	}

	toggleScrollOpacity(opacity, delay = 0) {
		if (typeof this.scroll !== 'object') {
			return false;
		}

		const el = $('.' + this.scroll.scrollbarClass);
		if (el.length) {
			setTimeout(() => {
				el.css('opacity', opacity === 0 ? 0 : '');
			}, delay)
		}
	}

	initBarba() {

		barba.hooks.beforeEnter((data) => {
			this.identifierPage(data)
			this.initAlways(data);
		});

		barba.hooks.beforeLeave((data) => {
			this.destroyAlways(data);
			this.toggleScrollOpacity(0);
		});

		barba.hooks.once((data) => {
			this.initOnce(data)
		});

		barba.hooks.afterEnter((data) => {
			//this.recalculateSmoothScroll();
			this.initAlwaysEnter(data);
			this.toggleScrollOpacity(1, 500);

		});

		barba.hooks.leave((data) => {
			setTimeout(() => {
				this.mm.add('(min-width:992px)', () => {
					window.scroller.scrollTo(document.querySelector('[data-scroll-container]').offsetTop, {
						duration: 0.1,//0.1
						disableLerp: true
					});
				});

				this.mm.add('(max-width:991px)', () => {
					window.scrollTo(0, 0);
				});

			}, this.speed * 1000);

		});

		barba.init({
			prefetchIgnore: [
				'/company/(.*)',
				'/team-member/(.*)',
				'/story/(.*)',
				'/founder/(.*)',
				'/jobs/(.*)',
				'/global-presence/(.*)',
			],
			// debug: false,
			// Uncomment the line below to see the BarbaJS errors in the console
			debug: true,
			// logLevel: 'error',
			prevent: (data) => {
				const { el, href, event } = data;
				const base_url = window.location.origin;
				const arrayFocusArea = [
					'enterprise',
					'healthcare',
					'consumer',
					'fintech',
					'gaming',
					'blockchain',
				];

				const excludedPaths = [
					'launch',
					'gametheory',
				];

				const isExcludedPath = excludedPaths.some(path => 
					href === `${base_url}/${path}` || href === `${base_url}/${path}/`
				);

				return (
					el.classList &&
					(el.classList.contains('ab-item') ||
						el.parentElement.classList.contains('ab-item') ||
						document.querySelector(
							'body[data-template="seed-program"]'
						) ||
						document.querySelector('.page-launch') ||
						isExcludedPath ||
						arrayFocusArea.map((item) => {
							return (
								href ===
									base_url +
										'/' +
										'focus-area-' +
										item +
										'/' ||
								href ===
									base_url + '/' + 'focus-area-' + item ||
								document.querySelector(
									'page-focus-area-' + item
								)
							);
						}))
				);
			},
			timeout: 12000,
			sync: true,
			transitions: [
				{
					name: 'slide-up-transition',
					once: ({ next }) => {
						if (
							next.namespace === 'home' ||
							next.namespace === 'home-india' ||
							next.namespace === 'cyber60' ||
							next.namespace === 'gametheory'
						) {
							gsap.set(next.container, { autoAlpha: 1 });
							return;
						}

						this.onceTransition = gsap
							.timeline({
								onStart: () => {
									setTimeout(() => {
										this.mm.add('(min-width:992px)', () => {
											window.scroller.scrollTo(
												document.querySelector(
													'[data-scroll-container]'
												).offsetTop,
												{
													duration: 0.1, //0.1
												}
											);
										});

										this.mm.add('(max-width:991px)', () => {
											window.scrollTo(0, 0);
										});
									}, 100);
								},
								onComplete: () => {
									this.onceTransition.kill();
									this.onceTransition = null;
								},
							})
							.set(next.container, { y: 100, autoAlpha: 0 })
							.to(next.container, {
								autoAlpha: 1,
								ease: 'circ.out',
								duration: this.speed,
								delay: 0.5,
								y: 0,
								clearProps: 'y',
							});

						return this.onceTransition;
					},
					leave: (data) => {
						gsap.set(document.querySelector('#footer'), {
							autoAlpha: 0,
						});
						this.leaveTransition = gsap
							.timeline({
								onComplete: () => {
									this.leaveTransition.kill();
									this.leaveTransition = null;
								},
							})
							.to(data.current.container, {
								autoAlpha: 0,
								ease: 'circ.out',
								duration: this.speed,
								y: 100,
								clearProps: 'all',
								onStart: () => {},
							})
							.set(data.current.container, {
								opacity: 0,
								y: 0,
							});

						return this.leaveTransition;
					},
					enter: (data) => {
						if (data.next.namespace !== 'home') {
							gsap.set(data.next.container, { autoAlpha: 1 });
							this.enterTransititon = gsap
								.timeline()
								.from(data.next.container, {
									autoAlpha: 0,
									ease: 'circ.out',
									delay: 0.5,
									y: 200,
									duration: this.speed,
									clearProps: 'y',
									onStart: () => {},
									onComplete: () => {
										gsap.set(
											document.querySelector('#footer'),
											{ autoAlpha: 1 }
										);
										this.enterTransititon.kill();
										this.enterTransititon = null;
									},
								});
						} else {
							setTimeout(() => {
								gsap.set(data.next.container, { autoAlpha: 1 });
								gsap.set(document.querySelector('#footer'), {
									autoAlpha: 1,
								});
							}, 700);
						}
					},
				},
			],
			views: [
				{
					namespace: 'home',
					beforeEnter: (data) => {
						Helper.HomeHeroImages(data).then((a) => {
							const bannerHomeEl =
								data.next.container.querySelector(
									'#banner-type-2'
								);
							if (bannerHomeEl) {
								HomeBanner.create(bannerHomeEl);
							}
							SliderFounders.create({
								selector:
									data.next.container.querySelector(
										'.swiper-founder'
									),
								container: data.next.container,
								namespace: data.next.namespace,
								next: "[data-barba-namespace='home'] .founder-section .swiper-button-next",
								prev: "[data-barba-namespace='home'] .swiper-button-prev",
								pagination:
									'[data-barba-namespace="home"]  .founder-section .swiper-pagination',
							});
						});
					},
					beforeLeave: () => {
						HomeBanner.destroy();
						SliderFounders.destroy();
					},
				},
				{
					namespace: 'home-india',
					beforeEnter: (data) => {
						Helper.HomeHeroImages(data).then((a) => {
							const bannerHomeEl =
								data.next.container.querySelector(
									'#banner-type-2'
								);
							if (bannerHomeEl) {
								HomeBanner.create(bannerHomeEl);
							}

							SliderFounders.create({
								selector:
									data.next.container.querySelector(
										'.swiper-founder'
									),
								container: data.next.container,
								namespace: data.next.namespace,
								next: "[data-barba-namespace='home-india'] .founder-section .swiper-button-next",
								prev: "[data-barba-namespace='home-india'] .founder-section .swiper-button-prev",
								pagination:
									'[data-barba-namespace="home-india"]  .founder-section .swiper-pagination',
								breakpoints: {
									768: {
										slidesPerView: 2,
										spaceBetween: 64,
										slidesPerGroup: 1,
									},
									1024: {
										slidesPerView: 2,
										spaceBetween: 64,
										slidesPerGroup: 1,
									},
									1280: {
										slidesPerView: 5,
										spaceBetween: 116,
										slidesPerGroup: 1,
									},
								},
							});
						});

						setTimeout(() => {
							SliderStories.create({
								selector: data.next.container.querySelector(
									'.swiper-stories:not(#specialists-swiper)'
								),
								next: '[data-barba-namespace="home-india"] .stories-slider-section .swiper-button-next',
								prev: '[data-barba-namespace="home-india"] .stories-slider-section .swiper-button-prev',
								pagination:
									'[data-barba-namespace="home-india"] .stories-slider-section .swiper-pagination',
								container: data.next.container,
							});
						}, 0);
					},
					beforeLeave: (data) => {
						HomeBanner.destroy();
						SliderStories.destroy();
						SliderFounders.destroy();
					},
				},
				{
					namespace: 'about',
					beforeEnter: (data) => {},
					beforeLeave: () => {},
				},
				{
					namespace: 'lighthouse',
					beforeEnter: (data) => {
						this.accordion = new Accordion({
							speed: 0.5,
							element: '[data-accordion]',
							container: data.next.container,
						});
					},
					beforeLeave: () => {
						this.accordion.destroy();
					},
				},
				{
					namespace: 'companies',
					beforeEnter: (data) => {
						if (
							typeof window.companiesAutocomplete === 'undefined'
						) {
							const nextScripts =
								data.next.container.querySelectorAll(
									'[data-script]'
								);
							nextScripts.forEach((script) => {
								if (!script.src) {
									const newScript = script.cloneNode(true);
									const newNode =
										document.createElement('script');
									newNode.innerHTML = newScript.innerHTML;
									const element =
										document.head.appendChild(newNode);
								}
								script.remove();
							});
						}
						CompaniesFilters.create({
							container: data.next.container,
						});
						setTimeout(() => {
							StopMainScroller.create({
								container: data.next.container,
							});
						}, 300);
					},
					afterEnter: (data) => {
						setTimeout(() => {
							if (
								data.trigger === 'back' &&
								data?.current?.route?.name === 'company'
							) {
								const isFounder =
									sessionStorage.getItem('founder');
								const companyId =
									data?.current?.route?.params?.id;
								const companyEl =
									isFounder === 'true'
										? data?.next?.container?.querySelector(
												`.section-founder-spotlight [data-company-id="${companyId}"]`
										  )
										: data?.next?.container?.querySelector(
												`.companies-wrapper [data-company-id="${companyId}"]`
										  );
								const offset =
									isFounder === 'true'
										? companyEl.getBoundingClientRect()
												.height * -1
										: companyEl.getBoundingClientRect()
												.height * -2;
								if (companyEl) {
									window.scroller.scrollTo(companyEl, {
										duration: 100,
										offset: offset,
									});
								}
							}
						}, 700);
					},
					beforeLeave: (data) => {
						CompaniesFilters.destroy(data);
						StopMainScroller.destroy();
					},
				},
				{
					namespace: 'lightspeed-team',
					beforeEnter: (data) => {
						if (typeof window.teamsAutocomplete === 'undefined') {
							const nextScripts =
								data.next.container.querySelectorAll(
									'[data-script]'
								);
							nextScripts.forEach((script) => {
								if (!script.src) {
									const newScript = script.cloneNode(true);
									const newNode =
										document.createElement('script');
									newNode.innerHTML = newScript.innerHTML;
									const element =
										document.head.appendChild(newNode);
								}
								script.remove();
							});
						}

						TeamsFilters.create({ container: data.next.container });
						setTimeout(() => {
							StopMainScroller.create({
								container: data.next.container,
							});
						}, 300);
					},
					beforeLeave: (data) => {
						TeamsFilters.destroy();
						StopMainScroller.destroy();
					},
				},
				{
					namespace: 'stories',
					beforeEnter: (data) => {
						if (typeof window.storiesAutocomplete === 'undefined') {
							const nextScripts =
								data.next.container.querySelectorAll(
									'[data-script]'
								);
							nextScripts.forEach((script) => {
								if (!script.src) {
									const newScript = script.cloneNode(true);
									const newNode =
										document.createElement('script');
									newNode.innerHTML = newScript.innerHTML;
									const element =
										document.head.appendChild(newNode);
								}
								script.remove();
							});
						}

						setTimeout(() => {
							this.StoriesFilters = new StoriesFilters({
								container: data.next.container,
							});
							//SLIDER
							SliderStories.create({
								selector: data.next.container.querySelector(
									'.swiper-stories:not(#specialists-swiper)'
								),
								next: '[data-barba-namespace="stories"] .swiper-button-next',
								prev: '[data-barba-namespace="stories"] .swiper-button-prev',
								pagination:
									'[data-barba-namespace="stories"] .swiper-pagination',
								container: data.next.container,
							});
						}, 0);
						setTimeout(() => {
							StopMainScroller.create({
								container: data.next.container,
							});
						}, 300);
					},
					beforeLeave: (data) => {
						this.StoriesFilters.destroy();
						SliderStories.destroy();
						StopMainScroller.destroy();
					},
				},
				{
					namespace: 'events',
					beforeEnter: (data) => {
						SliderStories.create({
							selector: data.next.container.querySelector(
								'.swiper-stories:not(#specialists-swiper)'
							),
							next: '.page-events .events-slider .swiper-button-next',
							prev: '.page-events .events-slider .swiper-button-prev',
							pagination:
								'.page-events  .events-slider .swiper-pagination',
							container: data.next.container,
						});
					},
					beforeLeave: (data) => {
						SliderStories.destroy();
					},
				},
				{
					namespace: 'advisory-council',
					beforeEnter: (data) => {
						SliderStories.create({
							selector: data.next.container.querySelector(
								'.swiper-stories:not(#specialists-swiper)'
							),
							next: '.page-advisory-council .events-slider .swiper-button-next',
							prev: '.page-advisory-council .events-slider .swiper-button-prev',
							pagination:
								'.page-advisory-council  .events-slider .swiper-pagination',
							container: data.next.container,
						});

						this.accordionA = new Accordion({
							speed: 0.5,
							element: '[data-accordion]',
							container: data.next.container,
						});
					},
					beforeLeave: (data) => {
						SliderStories.destroy();
						this.accordionA.destroy();
					},
				},
				{
					namespace: 'press-kits',
					beforeEnter: (data) => {
						if (typeof window.teamsAutocomplete === 'undefined') {
							const nextScripts =
								data.next.container.querySelectorAll(
									'[data-script]'
								);
							nextScripts.forEach((script) => {
								if (!script.src) {
									const nextScript = script.cloneNode(true);
									const newNode =
										document.createElement('script');
									newNode.innerHTML = nextScript.innerHTML;
									const element =
										document.head.appendChild(newNode);
								}

								script.remove();
							});
						}

						setTimeout(() => {
							TeamsFilters.create({
								container: data.next.container,
							});
						}, 0);
					},

					beforeLeave: (data) => {
						TeamsFilters.destroy();
					},
				},
				{
					namespace: 'lightspeed-launch',
					beforeEnter: (data) => {
						Accordion.create({
							speed: 0.5,
							element: '[data-accordion]',
							container: data.next.container,
						});
					},

					beforeLeave: (data) => {},
				},
				{
					namespace: 'focus-area',
					beforeEnter: (data) => {
						SliderFounders.create({
							selector:
								data.next.container.querySelector(
									'.swiper-founder'
								),
							container: data.next.container,
							namespace: data.next.namespace,
							next: "[data-barba-namespace='focus-area'] .team-slider-section .swiper-button-next",
							prev: "[data-barba-namespace='focus-area'] .team-slider-section .swiper-button-prev",
							pagination:
								'[data-barba-namespace="focus-area"]  .team-slider-section .swiper-pagination',
							mobileSpeed: 300,
						});

						const appearAfterTransitionItem =
							data.next.container.querySelectorAll(
								'[data-appear-after-transition]'
							);
						appearAfterTransitionItem.forEach((item) => {
							const boxes = item.querySelectorAll(
								'[data-appear-after-transition-item]'
							);
							gsap.from(boxes, {
								y: 200,
								opacity: 0,
								duration: 0.8,
								ease: 'power1.out',
								delay: 0.5,
								stagger: 0.1,
								clearProps: 'all',
								overwrite: true,
							});
						});

						setTimeout(() => {
							FocusArea.create();
						}, 1000);
					},

					beforeLeave: (data) => {
						FocusArea.destroy();
					},
				},
				{
					namespace: 'focus-area-ai',
					beforeEnter: (data) => {
						SliderFounders.create({
							selector:
								data.next.container.querySelector(
									'.swiper-founder'
								),
							container: data.next.container,
							namespace: data.next.namespace,
							next: "[data-barba-namespace='focus-area-ai'] .team-slider-section .swiper-button-next",
							prev: "[data-barba-namespace='focus-area-ai'] .team-slider-section .swiper-button-prev",
							pagination:
								'[data-barba-namespace="focus-area-ai"]  .team-slider-section .swiper-pagination',
							mobileSpeed: 300,
						});

						const appearAfterTransitionItem =
							data.next.container.querySelectorAll(
								'[data-appear-after-transition]'
							);
						appearAfterTransitionItem.forEach((item) => {
							const boxes = item.querySelectorAll(
								'[data-appear-after-transition-item]'
							);
							gsap.from(boxes, {
								y: 200,
								opacity: 0,
								duration: 0.8,
								ease: 'power1.out',
								delay: 0.5,
								stagger: 0.1,
								clearProps: 'all',
								overwrite: true,
							});
						});

						setTimeout(() => {
							FocusArea.create();
						}, 1000);
					},

					beforeLeave: (data) => {
						FocusArea.destroy();
					},
				},
				{
					namespace: 'cyber60',
					beforeEnter: (data) => {
						Cyber60.create(data.next.container);
					},

					beforeLeave: (data) => {
						Cyber60.destroy();
					},
				},
				{
					namespace: 'newsletter-2025-q1',
					beforeEnter: (data) => {
						Newsletter2025Q1.create(data.next.container);
					},

					beforeLeave: (data) => {
						Newsletter2025Q1.destroy();
					},
				}
			],
		});
		window.barba = barba;


	}

	initLocoScroll() {
		const os = Helper.detectOperatingSystem();
		const hasPotType = document.querySelector('[data-post-type]') !== null;
		this.scroll = new LocomotiveScroll({
			el: document.querySelector('[data-scroll-container]'),
			name: 'scroll',
			offset: [0, 0],
			repeat: true,
			smooth: !hasPotType,
			initPosition: {
				x: 0,
				y: 0,
			},
			direction: 'vertical',
			gestureDirection: 'vertical',
			class: 'is-inview',
			scrollbarContainer: false,
			scrollbarClass: 'c-scrollbar',
			scrollingClass: 'has-scroll-scrolling',
			draggingClass: 'has-scroll-dragging',
			smoothClass: 'has-scroll-smooth',
			initClass: 'has-scroll-init',
			getSpeed: true,
			getDirection: true,
			scrollFromAnywhere: false,
			multiplier: os === 'Mac' ? 0.75 : 1.5,
			firefoxMultiplier: 150,
			resetNativeScroll: false,

			tablet: {
				smooth: false,
				direction: 'vertical',
				gestureDirection: 'vertical',
			},
			smartphone: {
				smooth: false,
				direction: 'vertical',
				gestureDirection: 'vertical',
				reloadOnContextChange: true,
			},
		});

		window.scroller = this.scroll;
		ScrollTrigger.defaults({scroller: this.scroll});

	}

	locoscrolProxy() {
		window.scroller.on('scroll', () => {
			try {
				ScrollTrigger.update();
			} catch {
			}
		});
		ScrollTrigger.scrollerProxy("[data-scroll-container]", {
			scrollTop(value) {
				return window.scroller.scroll.instance.scroll.y;
			},
			getBoundingClientRect() {
				return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
			},
			pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed"
		});

		ScrollTrigger.addEventListener("refresh", () => {
			try {
				window.scroller.update();
			} catch {
			}
		});
		ScrollTrigger.refresh();
	}

	resizerObserver() {
		new ResizeObserver(() => {
			window.scroller.update();
			ScrollTrigger.refresh();
		}).observe(document.querySelector("[data-scroll-container]"));
	}

	initOnce(data) {
		Helper.MobileNav();
		Helper.CustomSelect();
		Helper.BrowserOsClass();
		Helper.HoverClassOnParent('.sub-nav a', '.sub-nav');
		Helper.HoverClassOnParent('.footer-nav a', '.footer-nav');
		Helper.HoverClassOnParent('.main-nav a', '.main-nav');
		Newsletter.Newsletter();
		Helper.Cyber60();
		Helper.playVideoOnScroll(window.scroller);

	}

	// NEXT TASK : COVERT ALL initAlways TO CLASS
	initAlwaysEnter(data) {



		setTimeout(() => {
			ScrollAnimations.create({selector: data.next.container, container: data.next.container});
			AppearAnimation.create({selector: data.next.container, container: data.next.container});
			ChartGraph.create();
			HorizontalTextScroller.create({
				selector: [...data.next.container.querySelectorAll("[data-horizontal-scroll-lines]")],
				container: data.next.container
			});
		}, this.speed * 2 * 1000);
	}

	initAlways(data) {
		Helper.focusAreaActivePage();
		Helper.ExternalLink();
		SpotLight.create(data.next.container);
		FoundersSpotlight();
		Helper.HoverClassOnParent();
		Helper.Filter();
		Helper.LinkBackBlog();
		ShareLink.ShareLink();
		VideoModal.create(data.next.container);
		Helper.OpenClose();
		LogoMobileWidth.create();
		Helper.setupWidthLinks();
		Helper.FactionModal();
		Helper.classOnLoad();
		Helper.RemoveImageBackground.create(
			data.next.container.querySelectorAll('[data-transparent-img]')
		);
		Helper.ResponsiveGradient(data.next.container);
		FilterSwitch.create({selector: data.next.container});
		CloseMenu.create();
		Newsletter2024Ai.create();

		// setTimeout(() => {
		// 	this.clockAnimation = new ClockAnimation(
		// 		document.querySelectorAll('.clock-list li')
		// 	);
		// }, 1000);
		FeedTabs.create([...document.querySelectorAll('[data-tab-feed]')]);
		SwipersSliders.create(data.next.container);
		Helper.Modal();
		Helper.firstSlideCaption();
		const cyber60El = document.getElementById('cyber60-hero-wrapper');
		if (cyber60El) {
			HeroCyber60.create(cyber60El);
		}



		VideoModalCarousel.create(data.next.container);
		Helper.TreeTabs();
		Helper.ImageWidth();
		Helper.extractYoutubeData();
		Helper.Marquee();
	}

	destroyAlways(data) {
		FeedTabs.destroy();
		SwipersSliders.destroy();
		ScrollAnimations.destroy(data)
		AppearAnimation.destroy()
		Helper.destroyOpenClose();
		HorizontalTextScroller.destroy();
		VideoModal.destroy();
		VideoModalCarousel.destroy();
		LogoMobileWidth.destroy();
		SpotLight.destroy();
		FilterSwitch.destroy();
		CloseMenu.destroy();
		Helper.RemoveImageBackground.destroy();
		ChartGraph.destroy();
		HeroCyber60.destroy();
	}

	recalculateSmoothScroll() {
		ScrollTrigger.refresh();
		window.scroller.update();
	}

	restartPage() {
		const desktop = window.matchMedia('screen and (min-width: 1440px)');
		const mobile = window.matchMedia('screen and (max-width: 1339px)');

		desktop.addListener(function (e) {
			if (e.matches) {
				location.reload();
			}
		});

		mobile.addListener(function (e) {
			if (e.matches) {
				location.reload();
			}
		});
	}

	reloadOnContextChange() {
		const desktop = window.matchMedia('screen and (min-width: 768px)');
		const mobile = window.matchMedia('screen and (max-width: 767px)');

		desktop.addListener(function (e) {
			if (e.matches) {
				console.log('app barba init')
				location.reload();

			}
		});

		mobile.addListener(function (e) {
			if (e.matches) {
				console.log('inita')
				location.reload();
			}
		});
	}

	init() {
		this.initLocoScroll();
		this.locoscrolProxy();
		this.resizerObserver();
		this.initBarba();
		this.reloadOnContextChange();

		window.updateLocoAndScrollTrigger = () => {
			window.scroller.update();
			ScrollTrigger.refresh();
		};
	}
}

export {AppBarba as default}
